export function map<T extends string, U>(obj: Record<T, U>, key: T): U {
  return obj[key];
}
